export const theme = {
  primary: "#FFBD35",
  secondary: "#FFFDDE",
  grayDark: "#292D32",
  grayLight: "#E7ECF3",
};
